import { render, staticRenderFns } from "./FormInputCheckbox.vue?vue&type=template&id=31ab17a4&"
import script from "./FormInputCheckbox.vue?vue&type=script&lang=js&"
export * from "./FormInputCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31ab17a4')) {
      api.createRecord('31ab17a4', component.options)
    } else {
      api.reload('31ab17a4', component.options)
    }
    module.hot.accept("./FormInputCheckbox.vue?vue&type=template&id=31ab17a4&", function () {
      api.rerender('31ab17a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwg/js/components/FormInputCheckbox.vue"
export default component.exports